import { RSet } from "../../collections";
import { makeImmutable } from "../../core/makeImmutable";
import { Tristate } from "../../core/Tristate";
/*
 * Always unavailable availability strategy
 */
export class Unavailable {
    constructor(reason) {
        this.reason = reason;
        makeImmutable(this);
    }
    get isAvailable() {
        return Tristate.False;
    }
    get unavailabilityReasons() {
        return RSet.singleton(this.reason);
    }
    accept(availabilityVisitor) {
        availabilityVisitor.visitUnavailable(this);
    }
}
